import {
	ADMINGETLOYALTYPOINT_SUCCESS,
	ADMINGETLOYALTYPOINT_FAILED,
	RESET_ADMINGETLOYALTYPOINT,
	LOADING_ADMINGETLOYALTYPOINT,
	NETWORK_ERROR_ADMINGETLOYALTYPOINT
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINGETLOYALTYPOINT:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINGETLOYALTYPOINT_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINGETLOYALTYPOINT_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINGETLOYALTYPOINT:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINGETLOYALTYPOINT:
			return (state = initialState);
		default:
			return state;
	}
};
